import { Grid, NumberInput, NumberInputProps } from '@mantine/core'

type Props = {
  widthProps: NumberInputProps
  heightProps: NumberInputProps
  disabled?: boolean
}

export default function SizeInput({ widthProps, heightProps, disabled }: Props) {
  return (
    <Grid>
      <Grid.Col span={6}>
        <NumberInput
          label="Szerokość"
          description="Szerokość przed zmarszczeniem"
          placeholder="500 cm"
          allowNegative={false}
          allowDecimal={false}
          max={2000}
          clampBehavior="strict"
          hideControls
          suffix=" cm"
          withAsterisk
          disabled={disabled}
          {...widthProps}
        />
      </Grid.Col>
      <Grid.Col span={6}>
        <NumberInput
          label="Wysokość"
          description="Wysokość w najdłuższym miejscu"
          placeholder="250 cm"
          allowNegative={false}
          allowDecimal={false}
          max={500}
          clampBehavior="strict"
          hideControls
          suffix=" cm"
          withAsterisk
          disabled={disabled}
          {...heightProps}
        />
      </Grid.Col>
    </Grid>
  )
}
